import { render } from "./BaladoSingle.vue?vue&type=template&id=c3f21382"
import script from "./BaladoSingle.vue?vue&type=script&lang=js"
export * from "./BaladoSingle.vue?vue&type=script&lang=js"
script.render = render

export default script